import { render } from "./BlockAccountModal.vue?vue&type=template&id=5588f6ea&scoped=true"
import script from "./BlockAccountModal.vue?vue&type=script&lang=js"
export * from "./BlockAccountModal.vue?vue&type=script&lang=js"

import "./BlockAccountModal.vue?vue&type=style&index=0&id=5588f6ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5588f6ea"]])

export default __exports__